import React, { Component } from 'react';

import ImageUserPlaceholder from './static/img/user-placeholder.jpg';

class SessionList extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() { 
        return (
            <div className="hw-widget__session-list">
                {this.props.children}
            </div>
        );
    }
}
 
export default SessionList;